import { Group, Skeleton, Text } from "@mantine/core";
import { StatCard } from "../StatCard";
import { TrendBadge } from "./TrendBadge";

interface Props {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  /** When provided, renders a TrendBadge next to the sub-line. */
  trend?: number | null;
  trendSuffix?: string;
  onClick?: () => void;
  loading?: boolean;
  accent?: "brand" | "green" | "red";
}

// A KPI tile = StatCard + an optional trend badge, with its own layout-preserving
// skeleton so the grid never reflows when the single dashboard fetch resolves.
export function KpiTile({ icon, label, value, sub, trend, trendSuffix, onClick, loading, accent }: Props) {
  if (loading) return <Skeleton height={132} radius="md" />;

  const showTrend = trend !== undefined;
  const subNode = (sub || showTrend) ? (
    <Group gap={6} wrap="wrap" align="center">
      {showTrend && <TrendBadge deltaPct={trend ?? null} suffix={trendSuffix} />}
      {sub && (showTrend ? <Text span size="xs" c="dimmed">· {sub}</Text> : sub)}
    </Group>
  ) : undefined;

  return (
    <StatCard icon={icon} label={label} value={value} sub={subNode} onClick={onClick} accent={accent} />
  );
}
